import { styled } from "goober";
import { PressButton } from "./PressButton";

export const FooterAction = styled(PressButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  padding: 4px 6px;
  margin: -4px -2px;
  border-radius: 4px;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: var(--alpha4);
  }

  &:active {
    background: var(--alpha8);
  }
`;
